<template>
  <router-view :realms="realms"/>
</template>

<script>
export default {
  name: 'Index',
  props: ['realms'],
}
</script>